/**
 *  考生答案模块
 */
import http from '../assets/js/http'
// 获取文件列表
export const getFileList = (params) => { return http.request({ url: '/examineeAnswer/getFileList', method: 'get', params: params }) }
// 获取音频列表
export const getAudioList = (params) => { return http.request({ url: '/examineeAnswer/getAudioList', method: 'get', params: params }) }
// 上传文件
export const uploadFile = (params) => { return http.request({ url: '/examineeAnswer/uploadFile', method: 'post', params: params, headers: { 'Content-Type': 'multipart/form-data' } }) }
// 上传录音
export const uploadAudio = (params) => { return http.request({ url: '/examineeAnswer/uploadAudio', method: 'post', params: params, headers: { 'Content-Type': 'multipart/form-data' } }) }
// 删除文件
export const removeFile = (params) => { return http.request({ url: '/examineeAnswer/removeFile', method: 'post', params: params }) }
// 删除录音
export const removeAudio = (params) => { return http.request({ url: '/examineeAnswer/removeAudio', method: 'post', params: params }) }
